import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UcrFormsModule } from '../forms/ucrforms.module';
import { SharedModule } from '../shared/shared.module';
import { TextEditComponent } from './text-edit/text-edit.component';
import { TextComponent } from './text.component';

@NgModule({
    declarations: [TextComponent, TextEditComponent],
    exports: [TextComponent],
    imports: [CommonModule, MatTooltipModule, MatIconModule, SharedModule, MatTabsModule, UcrFormsModule]
})
export class UcrTextModule {}
